import "./index.css";

import Pages from "./router/Pages";
import React from "react";

function App() {
  return <Pages />;
}

export default App;
